import { initializeApp } from "firebase/app";
import {
  getMessaging,
  getToken,
  onMessage,
  isSupported,
} from "firebase/messaging";
import { getAnalytics } from "firebase/analytics";
import { storeFcm } from "../features/fcmSlice";

// TODO: Replace the following with your app's Firebase project configuration
// See: https://firebase.google.com/docs/web/learn-more#config-object
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

let messaging;
let analytics;
if (isSupported()) {
  if (process.env.NODE_ENV !== "test") {
    const firebaseApp = initializeApp(firebaseConfig);
    messaging = getMessaging(firebaseApp);
    analytics = getAnalytics(firebaseApp);
  }
} else {
  console.log("Firebase Messaging is not supported in this browser.");
}

const setupNotifications = async (dispatch) => {
  const token = localStorage.getItem("token_user");
  if (process.env.NODE_ENV !== "test" && token) {
    try {
      // Request permission for notifications
      const permission = await Notification.requestPermission();

      if (permission === "granted") {
        console.log("Notification permission granted.");
        // Get the FCM token
        const token = await getToken(messaging);
        if (token) {
          dispatch(storeFcm(token));
        }
      } else {
        console.log("Notification permission denied.");
      }
      // Handle foreground notifications
      onMessage(messaging, (payload) => {
        console.log("Foreground Message:", payload);
        // Handle the notification or update your UI
      });
    } catch (error) {
      console.error("Error setting up notifications:", error);
    }
  }
};
export { messaging, setupNotifications, analytics };
